module.exports = __webpack_public_path__ + "static/media/python_old.e3fa60be.png";